var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInovationCurriculum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z",
    fill: "#ECB32C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 17V42H32V17H27ZM32 20.3333L38.6667 42L43.6667 40.3333L37 18.6667L32 20.3333ZM20.3333 20.3333V42H25.3333V20.3333H20.3333ZM17 43.6667V47H47V43.6667H17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInovationCurriculum);
export default __webpack_public_path__ + "static/media/inovation-curriculum.739e6ec49a75461c2d462b0e68093429.svg";
export { ForwardRef as ReactComponent };